/**
 * Sider内容组件 包括搜索区域和分组模块
 * created by liyaoh 2021-05-27
 */
import React, { useEffect, useState } from "react";
import { cloneDeep } from "lodash";
import platform from "Pub/js/platform";
import PLACEHOLDER from "Assets/images/searchplaceholder.png";
import SiderCard from "./siderCard";
import SearchArea from "./SiderSearch";
const { NCDiv, NCCheckbox } = platform.base;

function SiderContent(props) {
    const { json, contentData, showIcon } = props;
    const [groupData, setGroupData] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        const newGroupData = formatGroupData(contentData);
        setGroupData(newGroupData);
    }, [contentData]);

    //格式化contentData
    function formatGroupData(data) {
        if (!data) {return [];}
        let result = cloneDeep(data);
        result = result.map(item => {
            item.isShow = item.isShow !== undefined ? item.isShow : true;
            item.checkedAll = item.checkedAll !== undefined ? item.checkedAll : false;
            item.indeterminate = item.indeterminate !== undefined ? item.indeterminate : false;
            return item;
        });
        return result;
    }

    //全部展开/收起控制分组内容显隐
    const toggleGroupShow = isShow => {
        const newGroupData = groupData.map(item => {
            if (typeof isShow === "boolean") {
                item.isShow = isShow;
            }
            return item;
        });
        setGroupData(newGroupData);
    };

    //切换分组内容显隐
    const handleToggleGroupShow = index => {
        let newGroupData = cloneDeep(groupData);
        if (newGroupData[index]) {
            const isShow = !newGroupData[index].isShow;
            newGroupData[index].isShow = isShow;
            setGroupData(newGroupData);
            props.onGroupShowChange && props.onGroupShowChange(index, isShow);
        }
    };

    //分组全选
    const handleCheckAllChange = (checked, index) => {
        // const checked = e.target.checked;
        let newGroupData = cloneDeep(groupData);
        let selectGroup = newGroupData[index];
        selectGroup.checkedAll = checked;
        selectGroup.indeterminate = false;
        selectGroup.children.forEach(item => {
            item.checked = checked;
        });
        setGroupData(newGroupData);
        props.onCheckAllChange(newGroupData);
    };

    //选中sideCard
    const handleChangeChecked = (checked, groupIndex, index) => {
        let newGroupData = cloneDeep(groupData);
        let selectGroup = newGroupData[groupIndex];
        let child = selectGroup.children[index];
        child.checked = checked;

        let checkCount = 0;
        selectGroup.children.forEach(item => {
            if (item.checked) {
                checkCount++;
            }
        });

        selectGroup.checkedAll = checkCount === selectGroup.children.length;
        selectGroup.indeterminate = !!checkCount && checkCount < selectGroup.children.length;
        setGroupData(newGroupData);
        props.onChangeChecked(newGroupData, child.value);
    };

    //拿到icon的路径
    const getIconSrc = item => {
        let { iconList } = props;
        if(!showIcon) {return null;}
        const target = iconList && iconList.find(icon => icon.value === item.image_src);
        return target && target.src || '';
    };

    //空搜索结果
    const renderNoSearchResult = () => {
        return (
            contentData && (
                <div className="result-group-list">
                    <div className="no-result-content">
                        <div className="no-result">
                            <img
                                src={PLACEHOLDER}
                                alt={json["DesktopSetting-000035"]}
                                width="80"
                                className="commondataPlaceholder"
                            />
                            {/* /* 国际化处理： 无匹配结果*/}
                            <br />
                        </div>
                        <div className="no-result-character">{json["DesktopSetting-000042"]}</div>
                        {/* /* 国际化处理： 未查询到相关数据*/}
                    </div>
                </div>
            )
        );
    };

    const renderHeader = (item, index) => {
        const setleCheckAllChange = e => {
            e.stopPropagation();
            handleCheckAllChange(!item.checkedAll, index);
        };
        return (
            <div
                className="result-header"
                fieldid="result-header"
                onClick={() => {
                    handleToggleGroupShow(index);
                }}
            >
                <span className="checkbox-content" onClick={setleCheckAllChange}>
                    <NCCheckbox
                        checked={item.checkedAll}
                        indeterminate={item.indeterminate}
                        onChange={e => handleCheckAllChange(e, index)}
                    />
                </span>
                <span className="result-header-name" >
                    {item.label}
                </span>
                {item.isShow ? (
                    <i className="iconfont icon-jiantouxia1"></i>
                ) : (
                    <i className="iconfont icon-jiantouxia1 icon-right"></i>
                )}
            </div>
        );
    };
    //搜索结果
    const renderContent = () => {
        if (groupData && groupData.length) {
            return groupData.map((item, index) => {
                return (
                    <NCDiv
                        className="result-group-list"
                        key={item.value}
                        fieldid={item.label}
                        areaCode={NCDiv.config.Group}
                    >
                        {renderHeader(item, index)}
                        <div
                            className="result-app-list"
                            style={{ display: item.isShow ? "flex" : "none" }}
                        >
                            {item.children.map((child, i) => {
                                return (
                                    <div className="app-col" key={i} fieldid={child.label}>
                                        <div className="list-item">
                                            {showIcon && <div className="list-item-icon" style={{ backgroundImage: `url(${getIconSrc(child)})` }}></div>}
                                            {renderSiderCard(child, i, index)}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </NCDiv>
                );
            });
        } else {
            return renderNoSearchResult();
        }
    };

    const renderSiderCard = (child, i, groupIndex) => {
        if(props.renderSideCard) {
            return props.renderSideCard(child, i, groupIndex);
        } else {
            return (
                <SiderCard
                    id={child.value}
                    key={child.value}
                    width={child.width}
                    height={child.height}
                    index={i}
                    parentIndex={groupIndex}
                    searchValue={searchValue}
                    name={child.name}
                    appGroupArr={groupData}
                    checked={child.checked}
                    onChangeChecked={handleChangeChecked}
                    resetSelectedCards={props.resetSelectedCards}
                    cardList={props.cardList}
                    card={child}
                />
            );
        }
    };
    return (
        <div className="drag-sider-content">
            <SearchArea
                searchValue={searchValue}
                groupData={groupData}
                setSearchValue={setSearchValue}
                onAllExpand={toggleGroupShow}
                {...props}
            />
            <div className="sider-result">{renderContent()}</div>
        </div>
    );
}

export default SiderContent;
